var _defs, _path, _image, _polygon, _rect, _rect2, _polygon2, _rect3, _rect4, _polygon3, _polygon4, _rect5, _path2, _rect6, _rect7, _rect8, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 650 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#f5f3f5;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 399.1526,
    y1: 229.118,
    x2: 399.1526,
    y2: 314.7123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4344,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5819,
    stopColor: "#f5f3f5",
    stopOpacity: 0.6684
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7922,
    stopColor: "#f5f3f5",
    stopOpacity: 0.2894
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -3052.8225,
    y1: 2928.4663,
    x2: -3016.5408,
    y2: 2928.4663,
    gradientTransform: "translate(3443.3811 -2658.4686)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1477,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2283,
    stopColor: "#f5f3f5",
    stopOpacity: 0.976
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3351,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9078
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4565,
    stopColor: "#f5f3f5",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5888,
    stopColor: "#f5f3f5",
    stopOpacity: 0.6387
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7298,
    stopColor: "#f5f3f5",
    stopOpacity: 0.4374
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8758,
    stopColor: "#f5f3f5",
    stopOpacity: 0.1959
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 385.449,
    y1: 151.0145,
    x2: 332.2634,
    y2: 151.0145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2022,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4105,
    stopColor: "#f5f3f5",
    stopOpacity: 0.6556
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#f5f3f5",
    stopOpacity: 0.3747
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7546,
    stopColor: "#f5f3f5",
    stopOpacity: 0.1718
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    stopColor: "#f5f3f5",
    stopOpacity: 0.0469
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9384,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 399.1521,
    y1: 173.0726,
    x2: 399.1521,
    y2: 223.3001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2591,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3412,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9807
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9243
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5346,
    stopColor: "#f5f3f5",
    stopOpacity: 0.8308
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6381,
    stopColor: "#f5f3f5",
    stopOpacity: 0.6998
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7449,
    stopColor: "#f5f3f5",
    stopOpacity: 0.5314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8542,
    stopColor: "#f5f3f5",
    stopOpacity: 0.3252
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9637,
    stopColor: "#f5f3f5",
    stopOpacity: 0.0862
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -21183.8753,
    y1: 5135.7847,
    x2: -21183.8753,
    y2: 5181.0103,
    gradientTransform: "translate(-20784.7232 5498.516) rotate(180)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 227.5134,
    y1: 151.0599,
    x2: 279.3054,
    y2: 151.0599,
    gradientTransform: "translate(404.1873 -102.5174) rotate(89.9362)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 305.8171,
    y1: 122.3295,
    x2: 305.8171,
    y2: 186.0418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2591,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9732
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4239,
    stopColor: "#f5f3f5",
    stopOpacity: 0.8981
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5369,
    stopColor: "#f5f3f5",
    stopOpacity: 0.7747
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6625,
    stopColor: "#f5f3f5",
    stopOpacity: 0.6028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7986,
    stopColor: "#f5f3f5",
    stopOpacity: 0.3824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9413,
    stopColor: "#f5f3f5",
    stopOpacity: 0.1179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 281.8445,
    y1: 236.3656,
    x2: 354.8523,
    y2: 236.3656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0944,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9438
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2722,
    stopColor: "#f5f3f5",
    stopOpacity: 0.7956
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5143,
    stopColor: "#f5f3f5",
    stopOpacity: 0.5557
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#f5f3f5",
    stopOpacity: 0.2288
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 281.8445,
    y1: 282.056,
    x2: 327.0691,
    y2: 282.056,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 281.8445,
    y1: 327.7464,
    x2: 354.8523,
    y2: 327.7464,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -21926.6746,
    y1: 4926.1522,
    x2: -21926.6746,
    y2: 4896.9998,
    gradientTransform: "translate(-21673.1411 5150.7902) rotate(180)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -21926.6746,
    y1: 4883.3104,
    x2: -21926.6746,
    y2: 4854.158,
    gradientTransform: "translate(-21673.1411 5150.7902) rotate(180)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -21926.6746,
    y1: 4840.4686,
    x2: -21926.6746,
    y2: 4811.3162,
    gradientTransform: "translate(-21673.1411 5150.7902) rotate(180)",
    xlinkHref: "#linear-gradient-8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.1521,314.7123a42.7972,42.7972,0,1,1,42.7969-42.7974A42.8451,42.8451,0,0,1,399.1521,314.7123Zm0-76.7242A33.927,33.927,0,1,0,433.08,271.9149,33.9652,33.9652,0,0,0,399.1521,237.9881Z"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 83,
    height: 83,
    transform: "translate(373.2764 266.9563) scale(0.24)",
    xlinkHref: "data:image/png;base64,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"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "392.738 292.696 386.008 285.964 392.281 279.693 392.738 280.151 393.134 279.756 399.405 286.028 392.738 292.696"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 390.787,
    y: 265.799,
    width: 36.281,
    height: 8.8699,
    transform: "translate(-71.3198 368.2677) rotate(-44.9955)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 332.2634,
    y: 146.5794,
    width: 53.1855,
    height: 8.8701
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "403.587 173.073 394.718 173.073 394.718 155.45 385.449 155.45 385.449 146.579 403.587 146.579 403.587 173.073"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 394.7175,
    y: 173.0726,
    width: 8.8691,
    height: 50.2275
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 394.7175,
    y: 317.5057,
    width: 8.8691,
    height: 45.2256
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "403.587 377.672 208.051 377.672 208.051 173.073 216.921 173.073 216.921 368.802 394.718 368.802 394.718 362.731 403.587 362.731 403.587 377.672"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "216.921 173.073 208.051 173.073 208.051 146.575 227.523 146.596 227.513 155.466 216.921 155.454 216.921 173.073"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 248.9743,
    y: 125.1688,
    width: 8.8701,
    height: 51.7823,
    transform: "translate(102.0676 404.3011) rotate(-89.9362)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M359.2868,186.0418h-8.8691V176.0135a2.6384,2.6384,0,0,0-2.6357-2.6347l-24.3946.0727V148.2933a16.8259,16.8259,0,0,0-14.5322-16.79c-1.126-.1416-2.2773-.2354-3.418-.2779-.22-.01-.3476-.0171-.4746-.0171l-.1357-.0019a16.5936,16.5936,0,0,0-12.38,4.9307,15.4757,15.4757,0,0,0-4.4258,11.7841l.0059.2422v25.252l-24.1817-.0366a2.637,2.637,0,0,0-2.6289,2.6347v10.0283h-8.8691V176.0135a11.518,11.518,0,0,1,11.5049-11.5049l15.3056.023V148.2791A24.25,24.25,0,0,1,286.1,129.9408a25.5408,25.5408,0,0,1,18.9375-7.6021c.2324.0015.4668.0108.709.0215,1.4209.0532,2.834.1685,4.22.3428a25.7124,25.7124,0,0,1,22.29,25.59V164.555l15.5117-.0464a11.5209,11.5209,0,0,1,11.5185,11.5049Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 281.8445,
    y: 231.9305,
    width: 73.0078,
    height: 8.8701
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 281.8445,
    y: 277.6209,
    width: 45.2246,
    height: 8.8701
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 281.8445,
    y: 323.3114,
    width: 73.0078,
    height: 8.8701
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M268.1091,253.79H238.9577V224.638h29.1514Zm-20.2822-8.87H259.24V233.5082H247.8269Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M268.1091,296.6322H238.9577V267.48h29.1514Zm-20.2822-8.87H259.24V276.35H247.8269Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M268.1091,339.474H238.9577V310.3216h29.1514Zm-20.2822-8.87H259.24V319.1917H247.8269Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/Checklist.4c6f8ec7c920fe628de9b84b01e5b22c.svg";
export { ForwardRef as ReactComponent };